import { setToken, setUserId } from "@/helpers/localStorage";
import { useCopyTradeWallets } from "@/hooks/use-copy-trade-data";
import { useWallet, WalletType } from "@/providers/wallet";
import { Button } from "@/ui/button";
import WalletAddress from "@/ui/wallet-address";
import { displayWalletAddress } from "@/utils/wallet";
import { useWeb3Auth } from "@web3auth/modal-react-hooks";
import { useMemo } from "react";
import Select, { DataProp } from "./select";

const WalletSelector = ({
  className = "min-w-[6.875rem]",
  signInButtonClassName = "min-w-[6.875rem] font-semibold text-xs bg-red-500 hover:bg-red-600 text-white bg-red-500",
  selectedWalletType = undefined,
  isAllSelected,
  setIsAllSelected,
  hasAll = false,
}: {
  className?: string;
  signInButtonClassName?: string;
  isAllSelected: boolean;
  setIsAllSelected: (value: boolean) => void;
  selectedWalletType?: WalletType;
  hasAll?: boolean;
}) => {
  const { web3Auth, isConnected, connect } = useWeb3Auth();
  const { refreshWallets } = useCopyTradeWallets(isAllSelected);

  const { solanaAddresses, currentWallet, setWallet } = useWallet();

  const onLogin = async () => {
    await connect();
    if (!web3Auth) {
      return;
    }
    const { idToken } = await web3Auth.authenticateUser();
    setToken(idToken);
    const { email } = await web3Auth.getUserInfo();
    setUserId(email || "");
  };

  const handleWalletChange = ({ value }: DataProp) => {
    // Handle "All Wallets" selection
    if (value === "all-wallets") {
      setIsAllSelected(true);
      refreshWallets();
      return;
    }

    // // Handle Ethereum wallet selection
    // const walletEth = ethereumAddresses.find(
    //   ({ address }) => address === value
    // );
    // if (walletEth) {
    //   setWallet(walletEth);
    //   setIsAllSelected(false);
    //   refreshWallets();
    //   return;
    // }  Removed for now since ethereum is disabled for now  tag: eth-removal

    // Handle Solana wallet selection
    const walletSol = solanaAddresses.find(({ address }) => address === value);
    if (walletSol) {
      setWallet(walletSol);
      setIsAllSelected(false);
      refreshWallets();
      return;
    }
  };

  const data = useMemo(() => {
    // Create lists of wallet options
    // const ethereumAddressList = ethereumAddresses.map(({ address }) => {
    //   return {
    //     label: displayWalletAddress(address),
    //     value: address,
    //     component: <WalletAddress chainIcon="ethereum" address={address} />,
    //   };
    // }); Removed for now since ethereum is disabled for now tag: eth-removal

    const solanaAddressList = solanaAddresses.map(({ address }) => {
      return {
        label: displayWalletAddress(address),
        value: address,
        component: <WalletAddress chainIcon="solana" address={address} />,
      };
    });

    let walletList: { component: JSX.Element; label: string; value: string }[] =
      [];

    // Combine wallet lists based on selected wallet type
    if (!selectedWalletType) {
      walletList = solanaAddressList;
    } else if (selectedWalletType === WalletType.ETH) {
      // walletList = ethereumAddressList;
    } else if (selectedWalletType === WalletType.SOL) {
      walletList = solanaAddressList;
    }

    walletList.sort((a) => (a.value === currentWallet?.address ? -1 : 1));

    if (hasAll) {
      const allWalletsItem = {
        label: "All Wallets",
        value: "all-wallets",
        component: (
          <WalletAddress withIcon={false} fullAddress address="All Wallets" />
        ),
      };

      if (isAllSelected) {
        walletList.unshift(allWalletsItem);
      } else {
        walletList.push(allWalletsItem);
      }
    }

    return walletList;
  }, [
    // ethereumAddresses, Removed for now since ethereum is disabled for now tag: eth-removal
    solanaAddresses,
    selectedWalletType,
    hasAll,
    currentWallet?.address,
    isAllSelected,
  ]);

  return (
    <>
      {isConnected && (
        <Select
          isAllSelected={isAllSelected}
          className={className}
          key={"wallet-select"}
          data={data}
          initValue={data[0]}
          radius="bigger"
          onChange={handleWalletChange}
        />
      )}
      {!isConnected && (
        <Button
          activeStyle="sing-in-button"
          title="Sign in"
          hover={false}
          className={`${signInButtonClassName} bg-red-500`}
          enabled={true}
          onClick={() => {
            onLogin();
          }}
        />
      )}
    </>
  );
};

export default WalletSelector;
